(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("@blueprintjs/core"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types", "@blueprintjs/core"], factory);
	else if(typeof exports === 'object')
		exports["Icons"] = factory(require("react"), require("prop-types"), require("@blueprintjs/core"));
	else
		root["Hologram"] = root["Hologram"] || {}, root["Hologram"]["Icons"] = factory(root["react"], root["prop-types"], root["@blueprintjs/core"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__41__) {
return 